import React from 'react';

var Logo = function Logo() {
  return /*#__PURE__*/React.createElement("div", {
    className: "cloud-ui-nav-logo"
  }, /*#__PURE__*/React.createElement("svg", {
    height: "28",
    viewBox: "0 0 35 28",
    width: "35",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.662 13.13.003.017c-1.59.42-3.198.772-4.775 1.259a20.98 20.98 0 0 0 -11.815-5.28 38.405 38.405 0 0 1 22.283-7.217l-2.748 2.518s11.644-.417 14.58-4.427a5.377 5.377 0 0 1 -.378 1.215 13.12 13.12 0 0 1 -4.238 5.985 24.265 24.265 0 0 1 -6.042 3.441 57.874 57.874 0 0 1 -6.566 2.404l-.304.084zm18.263-.396c-4.22.588-12.352 4.762-18.218 8.031a21.105 21.105 0 0 0 -3.684-5.257c11.157-3.613 21.902-2.774 21.902-2.774zm-17.484 9.706 11.556-4.96-10.227 10.52a20.938 20.938 0 0 0 -1.33-5.56z",
    fill: "#ffa100"
  })));
};

export default Logo;